/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert HEX, RGB & HSL`)
};

const es_cv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte HEX, RGB e HSL`)
};

const de_cv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HEX, RGB & HSL konvertieren`)
};

const nl_cv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converteer HEX, RGB & HSL`)
};

const fr_cv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertissez HEX, RGB et HSL`)
};

const it_cv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti HEX, RGB e HSL`)
};

const pt_br2_cv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter HEX, RGB e HSL`)
};

const pt_cv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter HEX, RGB e HSL`)
};

const ja_cv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HEX、RGB、HSLを変換する`)
};

const zh_cv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转换HEX、RGB与HSL`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cv_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cv_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cv_nav_main_desc", locale)
	if (locale === "en") return en_cv_nav_main_desc(inputs)
	if (locale === "es") return es_cv_nav_main_desc(inputs)
	if (locale === "de") return de_cv_nav_main_desc(inputs)
	if (locale === "nl") return nl_cv_nav_main_desc(inputs)
	if (locale === "fr") return fr_cv_nav_main_desc(inputs)
	if (locale === "it") return it_cv_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_cv_nav_main_desc(inputs)
	if (locale === "pt") return pt_cv_nav_main_desc(inputs)
	if (locale === "ja") return ja_cv_nav_main_desc(inputs)
	return zh_cv_nav_main_desc(inputs)
};